import { render } from "./experience.vue?vue&type=template&id=2cb73afd&scoped=true"
import script from "./experience.vue?vue&type=script&lang=js"
export * from "./experience.vue?vue&type=script&lang=js"

import "./experience.vue?vue&type=style&index=0&id=2cb73afd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb73afd"]])

export default __exports__